const MeetingRoomReservation = () => {
  return <div />;
};

export default MeetingRoomReservation;
